<div class="form-container">
  <form [formGroup]="appointmentForm">
    <div class="row">
      <div class="form-field">
        <label for="location">Location<span class="required">*</span></label>
        <mat-select
          formControlName="location"
          placeholder="Select location"
          (selectionChange)="onLocationChange()"
          [class.error]="
            appointmentForm.get('location')?.errors && appointmentForm.get('location')?.touched
          "
        >
          <mat-option *ngFor="let location of locations" [value]="location.value">{{
            location.label
          }}</mat-option>
        </mat-select>
        <div class="error-message" *ngIf="getFieldError('location')">
          {{ getFieldError('location') }}
        </div>
      </div>
      <div class="form-field">
        <label for="staff">Staff<span class="required">*</span></label>
        <mat-select
          formControlName="staff"
          placeholder="Select staff"
          [class.error]="
            appointmentForm.get('staff')?.errors && appointmentForm.get('staff')?.touched
          "
        >
          <mat-option *ngFor="let option of staffOptions" [value]="option.value">{{
            option.label
          }}</mat-option>
        </mat-select>
        <div class="error-message" *ngIf="getFieldError('staff')">
          {{ getFieldError('staff') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-field">
        <label for="date-time">Date & Time<span class="required">*</span></label>
        <div class="custom-select">
          <app-custom-date-picker
            formControlName="date"
            [timeSlots]="timeSlots"
            [locationDetails]="locationDetails"
            placeholder="Select date and time"
            [fixedOverlay]="true"
            [class.error]="
              appointmentForm.get('date')?.errors && appointmentForm.get('date')?.touched
            "
          >
          </app-custom-date-picker>
        </div>
        <div class="error-message" *ngIf="getFieldError('date')">
          {{ getFieldError('date') }}
        </div>
      </div>
      <div class="form-field">
        <label for="duration">Duration<span class="required">*</span></label>
        <mat-select
          formControlName="duration"
          placeholder="Select duration"
          [class.error]="
            appointmentForm.get('duration')?.errors && appointmentForm.get('duration')?.touched
          "
        >
          <mat-option *ngFor="let duration of durationOptions" [value]="duration.value">{{
            duration.label
          }}</mat-option>
        </mat-select>
        <div class="error-message" *ngIf="getFieldError('duration')">
          {{ getFieldError('duration') }}
        </div>
      </div>
    </div>

    <div class="">
      <div class="notify" *ngIf="showShopTimezoneWarning">
        <p>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8.99935" cy="9.00033" r="8.33333" fill="#F57600" />
            <path
              d="M8.99203 11.5H8.99951"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 9L9 5.66667"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Appointment times are shown and scheduled in the selected location’s time zone.
        </p>
      </div>
      <div class="notify">
        <p>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8.99935" cy="9.00033" r="8.33333" fill="#F57600" />
            <path
              d="M8.99203 11.5H8.99951"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 9L9 5.66667"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Bookings are allowed only for available workdays and time slots; other times are disabled.
        </p>
      </div>
    </div>
  </form>
</div>
